(() => {
  const productLinks = [
    [/\bmia(?:\s|-)?(?:2|3)?\b/i, '/products/mia-3'],
    [/\bora(?:\s|-)?(?:2|3)?\b/i, '/products/ora-3'],
    [/smart(?:\s|-)?wand/i, '/products/smart-wand-2-medium'],
    [/sona(?:\s|-)?2.*cruise|sona(?:\s|-)?cruise/i, '/products/sona-2-cruise'],
    [/\bsona(?:\s|-)?2\b/i, '/products/sona-2'],
    [/\bsila\b/i, '/products/sila'],
    [/\bsoraya(?:\s|-)?2?\b/i, '/products/soraya-2'],
    [/enigma(?:\s|-)?wave/i, '/products/enigma-wave'],
    [/tiani(?:\s|-)?duo/i, '/products/tiani-duo'],
    [/\btor(?:\s|-)?3\b/i, '/products/tor-3'],
  ];

  const mediaDescription = (link) => {
    const images = Array.from(link.querySelectorAll('img'));
    return [
      link.getAttribute('href') || '',
      ...images.flatMap((image) => [
        image.getAttribute('alt') || '',
        image.getAttribute('title') || '',
        image.currentSrc || image.getAttribute('src') || '',
      ]),
    ].join(' ');
  };

  const unwrapExternalMediaLink = (link) => {
    const media = document.createElement('span');
    media.className = 'lelo-article-media';
    while (link.firstChild) media.appendChild(link.firstChild);
    link.replaceWith(media);
  };

  const repairArticleMediaLinks = (root = document) => {
    root.querySelectorAll('.lelo-volonte-article .article-template__content a[href]').forEach((link) => {
      if (!link.querySelector('img, picture')) return;

      let destination;
      try {
        destination = new URL(link.href, window.location.origin);
      } catch (_error) {
        unwrapExternalMediaLink(link);
        return;
      }

      if (destination.hostname === window.location.hostname) return;

      const description = mediaDescription(link);
      const match = productLinks.find(([pattern]) => pattern.test(description));

      if (match) {
        link.href = match[1];
        link.removeAttribute('target');
        link.removeAttribute('rel');
        link.dataset.xxooMediaLink = 'product';
        return;
      }

      unwrapExternalMediaLink(link);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => repairArticleMediaLinks());
  } else {
    repairArticleMediaLinks();
  }

  document.addEventListener('shopify:section:load', (event) => repairArticleMediaLinks(event.target));
})();
